import { useConditionalFeature } from '@americanexpress/conditional-features';
import { useMemo } from 'react';
import { useChildAgeRange } from './useChildAgeRange';
import {
  hasChildAgeDropdownGoToZero,
  hasChildAgeJapanUnderTwoLabel,
} from '../constants/featureConstants';

const generateNumericalDropdownOptionsUtil = (min, max) => {
  const ages = [];
  for (let ageIndex = min; ageIndex <= max; ageIndex += 1) {
    ages.push(
      { value: ageIndex.toString(), label: ageIndex.toString() }
    );
  }
  return ages;
};

export const useChildAgeDropdowns = () => {
  const { min, max } = useChildAgeRange();
  const hasJapanUnderTwoLabel = useConditionalFeature(hasChildAgeJapanUnderTwoLabel);
  const hasChildAgeDownToZero = useConditionalFeature(hasChildAgeDropdownGoToZero);

  const memoOptions = useMemo(() => {
    let options = generateNumericalDropdownOptionsUtil(min, max);
    if (!hasChildAgeDownToZero) {
      options = [
        { value: '1', label: hasJapanUnderTwoLabel ? '2歳未満' : '< 2' },
        ...options.filter((option) => Number(option.value) > 2),
      ];
    }

    return options;
  }, [min, max, hasJapanUnderTwoLabel, hasChildAgeDownToZero]);

  return memoOptions;
};
